export const DEFAULT_MAX_TRIAL_DAYS = 7;

export const maxTrialDaysFor = (userData = {}) => {
  const days = Number(userData?.max_trial_days);
  return days > 0 ? days : DEFAULT_MAX_TRIAL_DAYS;
};

export const canStartMaxUpgradeTrial = (userData = {}) => {
  const billingPlanTier =
    userData?.billing_subscription_plan_tier || userData?.subscription_plan_tier;

  return (
    Boolean(userData?.has_active_subscription) &&
    userData?.subscription_provider === "stripe" &&
    userData?.subscription_status === "active" &&
    billingPlanTier !== "max" &&
    userData?.max_trial_eligible !== false &&
    !userData?.max_trial_active
  );
};

export const shouldShowMaxUpgradeCta = (userData = {}) => {
  const billingPlanTier =
    userData?.billing_subscription_plan_tier || userData?.subscription_plan_tier;
  const nonMaxStripeSubscriber =
    Boolean(userData?.has_active_subscription) &&
    userData?.subscription_provider === "stripe" &&
    billingPlanTier !== "max";

  return (
    nonMaxStripeSubscriber &&
    ["active", "trialing"].includes(userData?.subscription_status) &&
    !userData?.max_trial_active
  );
};

export const maxUpgradePathFor = (userData = {}) =>
  canStartMaxUpgradeTrial(userData)
    ? "/plan-selection?max_trial=1#max"
    : "/plan-selection#max";

export const maxUpgradeButtonLabelFor = (userData = {}) =>
  canStartMaxUpgradeTrial(userData) ? "Try Max" : "Go Max";

export const maxTrialPrimaryLabelFor = (userData = {}) =>
  `Try MAX ${maxTrialDaysFor(userData)} Days Free`;

export const buildMaxUpgradeModalProps = (userData = {}, copy = {}) => {
  if (!canStartMaxUpgradeTrial(userData)) {
    return {
      eyebrow: copy.eyebrow || "Incite Max",
      title: copy.title,
      description: copy.description,
      bullets: copy.bullets,
      footer: copy.footer,
      primaryLabel: copy.primaryLabel || "Get Max",
      secondaryLabel: copy.secondaryLabel,
    };
  }

  const days = maxTrialDaysFor(userData);

  return {
    eyebrow: `${days}-Day MAX Trial`,
    title: copy.trialTitle || `Try MAX free for ${days} days.`,
    description: copy.trialDescription || copy.description,
    bullets: copy.trialBullets || copy.bullets,
    footer:
      copy.trialFooter ||
      `Today is $0. Your Pro subscription stays active during the ${days}-day trial.`,
    primaryLabel: copy.trialPrimaryLabel || maxTrialPrimaryLabelFor(userData),
    secondaryLabel: copy.secondaryLabel,
  };
};
